<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <monthly-tier-bonus-table />
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import MonthlyTierBonusTable from './MonthlyTierBonusTable.vue'

  export default {
    name: 'memberLevel',
    components: {MonthlyTierBonusTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/jeetPrivilege/vipProgram/MonthlyTierBonus.vue